import { useEffect, useId, useRef, useState } from 'react';
import { CircleHelp } from 'lucide-react';
import type { AccountView } from '../types';
import { money } from './Format';

export function RiskHint({ risk }: { risk: NonNullable<AccountView['risk']> }) {
  const id = useId();
  const container = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const [pinned, setPinned] = useState(false);
  const visible = open || pinned;

  useEffect(() => {
    if (!visible) return;
    const close = () => { setOpen(false); setPinned(false); };
    const onPointerDown = (event: PointerEvent) => {
      if (!container.current?.contains(event.target as Node)) close();
    };
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') close();
    };
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [visible]);

  return (
    <div ref={container} className="risk-hint" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) { setOpen(false); setPinned(false); }
      }}>
      <button type="button" className="risk-help-button" aria-label="查看风险边界" aria-expanded={visible}
        aria-controls={id} aria-describedby={visible ? id : undefined} onFocus={() => setOpen(true)}
        onClick={() => {
          setPinned(!pinned);
          if (pinned) setOpen(false);
        }}>
        <CircleHelp size={20} />
      </button>
      <div id={id} className="risk-tooltip" role="tooltip" hidden={!visible}>
        <strong>风险边界</strong>
        <dl>
          <div><dt>单笔最大金额</dt><dd>{money(risk.maxOrderUsdt)} <small>USDT</small></dd></div>
          <div><dt>账户最大敞口</dt><dd>{money(risk.maxTotalExposureUsdt)} <small>USDT</small></dd></div>
          <div><dt>单日最大亏损</dt><dd>{money(risk.maxDailyLossUsdt)} <small>USDT</small></dd></div>
          <div><dt>测试订单金额</dt><dd>{money(risk.testOrderUsdt)} <small>USDT</small></dd></div>
        </dl>
      </div>
    </div>
  );
}
